<template>
  <v-tabs v-show="show" :color="color" class="rounded-0" background-color="transparent">
    <v-tab v-if="delivery" to="/address">
      {{ $dictionary.get('delivery') }}
    </v-tab>
    <v-tab v-if="pickup" to="/pickup">
      {{ $dictionary.get('pickup') }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: 'DeliveryOrPickUpSwitcher',
  props: {},
  data: () => ({ }),
  computed: {
    delivery() {
      return this.$store.state.data.settings.has_delivery;
    },
    pickup() {
      return this.$store.state.data.settings.has_pickup;
    },
    dark() { return this.$store.state.theme.buttonDark; },
    color() { return this.$store.state.theme.buttonColor; },
    show() {
      return this.delivery && this.pickup;
    }
  },
  mounted() {
    if (this.$route.name === 'address' && !this.delivery && this.pickup) {
      this.$router.push('/pickup');
    } else if (this.$route.name === 'pickup' && !this.pickup && this.delivery) {
      this.$router.push('/address');
    }
  },
  methods: {
  }
};
</script>
